/** 星表示(docs/02_game_design.md §5.6。Unity版3つ→5つ)。 */

interface Props {
  readonly value: number;
  readonly max?: number;
  readonly size?: 'sm' | 'md' | 'lg';
  /** 1つずつ出す演出(リザルト用)。 */
  readonly animated?: boolean;
}

export function Stars({ value, max = 5, size = 'md', animated = false }: Props) {
  return (
    <div className={`stars stars-${size}`} aria-label={`ほし ${value} / ${max}`}>
      {Array.from({ length: max }, (_, index) => (
        <span
          key={index}
          className={`star ${index < value ? 'on' : 'off'} ${animated && index < value ? 'pop' : ''}`}
          style={animated ? { animationDelay: `${index * 180}ms` } : undefined}
        >
          ★
        </span>
      ))}
    </div>
  );
}
